import { careModelAnalytics } from 'src/services/analytics';

// eslint-disable-next-line import/prefer-default-export
export function useCohortAutoAssignAnalytics(surface) {
  function trackBannerShown(clientsCount) {
    careModelAnalytics.trackCohortAutoAssignBannerShown(
      surface,
      clientsCount,
    );
  }

  function trackBannerClicked(clientsCount) {
    careModelAnalytics.trackCohortAutoAssignBannerClicked(
      surface,
      clientsCount,
    );
  }

  function trackStepOneViewed(clientsCount) {
    careModelAnalytics.trackCohortAutoAssignStepOneViewed(
      surface,
      clientsCount,
    );
  }

  function trackStepOneConfirmed(acceptedCount, ignoredCount) {
    careModelAnalytics.trackCohortAutoAssignStepOneConfirmed(
      surface,
      acceptedCount,
      ignoredCount,
    );
  }

  function trackStepTwoViewed(clientsCount, entryPoint) {
    careModelAnalytics.trackCohortAutoAssignStepTwoViewed(
      surface,
      clientsCount,
      entryPoint,
    );
  }

  function trackStepTwoCompleted(
    manuallyAssignedCount,
    remainingUnassignedCount,
  ) {
    careModelAnalytics.trackCohortAutoAssignStepTwoCompleted(
      surface,
      manuallyAssignedCount,
      remainingUnassignedCount,
    );
  }

  function trackCancelled(step) {
    careModelAnalytics.trackCohortAutoAssignCancelled(
      surface,
      step,
    );
  }

  return {
    trackBannerShown,
    trackBannerClicked,
    trackStepOneViewed,
    trackStepOneConfirmed,
    trackStepTwoViewed,
    trackStepTwoCompleted,
    trackCancelled,
  };
}
